import { jwtDecode } from 'jwt-decode';
import { SessionStorageService } from './session-storage';
import { User } from '@/services/auth-service';

const USER_TOKEN_KEY = 'current-user-token';

const storage = new SessionStorageService<string>(USER_TOKEN_KEY);

export class UserStorage {
  get current(): User | undefined {
    const token = this.token;

    if (!token) {
      return undefined;
    }

    const decoded = jwtDecode(token) as User;

    return decoded;
  }

  get token() {
    return storage.data;
  }

  saveToken(token: string) {
    storage.save(token);
  }

  remove() {
    storage.remove();
  }
}
